module.exports = __webpack_public_path__ + "static/media/globalSearchBackground.41258b14.png";